import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, Suspense as _Suspense, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "grid" }
const _hoisted_2 = { class: "col-12 lg:col-4" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "p-fluid" }
const _hoisted_5 = { class: "card" }
const _hoisted_6 = { class: "p-fluid" }
const _hoisted_7 = { class: "col-12 lg:col-4" }
const _hoisted_8 = { class: "col-12 lg:col-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FieldText = _resolveComponent("FieldText")!
  const _component_PrimeVueButton = _resolveComponent("PrimeVueButton")!
  const _component_UserContactInformation = _resolveComponent("UserContactInformation")!
  const _component_PrimeVueSkeleton = _resolveComponent("PrimeVueSkeleton")!
  const _component_PrimeVueMessage = _resolveComponent("PrimeVueMessage")!
  const _component_PublisherPayoutInformation = _resolveComponent("PublisherPayoutInformation")!
  const _component_Entry = _resolveComponent("Entry")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_Entry, {
    "entry-errors-map": _ctx.profileErrorsMap,
    "onUpdate:entryErrorsMap": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.profileErrorsMap) = $event)),
    title: _ctx.$t('profile'),
    entry: _ctx.profile,
    "entry-store-handler": _ctx.storeProfile
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_FieldText, {
                modelValue: _ctx.profile.email,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.profile.email) = $event)),
                modelModifiers: { trim: true },
                name: "email",
                "errors-map": _ctx.profileErrorsMap,
                label: _ctx.$t('email'),
                disabled: ""
              }, null, 8, ["modelValue", "errors-map", "label"])
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_FieldText, {
                modelValue: _ctx.profile.password,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.profile.password) = $event)),
                modelModifiers: { trim: true },
                name: "password",
                "errors-map": _ctx.profileErrorsMap,
                label: _ctx.$t('new_password'),
                "input-group": true
              }, {
                append: _withCtx(() => [
                  _withDirectives((_openBlock(), _createBlock(_component_PrimeVueButton, {
                    class: "p-button-secondary",
                    onClick: _ctx.generatePassword
                  }, {
                    default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                      _createTextVNode("🎲", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"])), [
                    [
                      _directive_tooltip,
                      _ctx.$t('generate_password'),
                      void 0,
                      { top: true }
                    ]
                  ])
                ]),
                _: 1
              }, 8, ["modelValue", "errors-map", "label"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(), _createBlock(_Suspense, null, {
            default: _withCtx(() => [
              _createVNode(_component_UserContactInformation, {
                modelValue: _ctx.profile,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.profile) = $event)),
                "errors-map": _ctx.profileErrorsMap
              }, null, 8, ["modelValue", "errors-map"])
            ]),
            fallback: _withCtx(() => [
              _createVNode(_component_PrimeVueSkeleton, { height: "10px" })
            ]),
            _: 1
          }))
        ]),
        _createElementVNode("div", _hoisted_8, [
          (_ctx.activeUser.isAffiliate())
            ? (_openBlock(), _createBlock(_component_PrimeVueMessage, {
                key: 0,
                class: "mt-0",
                severity: "warn",
                closable: false
              }, {
                default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                  _createTextVNode("To change your publisher payout information, please contact support", -1)
                ]))]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_openBlock(), _createBlock(_Suspense, null, {
            default: _withCtx(() => [
              _createVNode(_component_PublisherPayoutInformation, {
                modelValue: _ctx.profile,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.profile) = $event)),
                "errors-map": _ctx.profileErrorsMap,
                disabled: _ctx.activeUser.isAffiliate()
              }, null, 8, ["modelValue", "errors-map", "disabled"])
            ]),
            fallback: _withCtx(() => [
              _createVNode(_component_PrimeVueSkeleton, { height: "10px" })
            ]),
            _: 1
          }))
        ])
      ])
    ]),
    _: 1
  }, 8, ["entry-errors-map", "title", "entry", "entry-store-handler"]))
}